export default "__VITE_ASSET__16131622__"